import React from 'react'
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

type MobileMenuSectionProps = {
  value: string
  label: string
  children: React.ReactNode
}

/** One top-level mobile menu (File, Edit, …): an accordion item of the menu sheet. */
export const MobileMenuSection: React.FC<MobileMenuSectionProps> = ({ value, label, children }) => {
  return (
    <AccordionItem value={value}>
      <AccordionTrigger className="leading-[20px] px-0">{label}</AccordionTrigger>
      <AccordionContent className="flex flex-col gap-0 p-0">{children}</AccordionContent>
    </AccordionItem>
  )
}
